import { put, takeEvery, all } from "redux-saga/effects";
import { GET_TICKETS } from "../constants/tickets";
import apiService from "../../Services/ApiService";
import { toastNotification } from "../../utils/toastNotification";
import { saveTickets } from "../actions/tickets";
import moment from "moment";

const convertTicketFormatToUiFormat = (type, tickets) => {
    let endResults = {
        count: tickets.count,
        data: []
    };

    if (type == "ticket-queues-custom") {
        endResults.data = tickets.data.map((ticket, index) => {
            // let data = JSON.parse(JSON.stringify(ticket.data));
            let data = ticket.data;
            return {
                name: `${data.visitor_first_name ? data.visitor_first_name : "Unknown"} ${data.visitor_last_name || ""}`,
                email: data.visitor_email,
                phone: data.visitor_phone || null,
                last_message: data.visitor_last_message ? data.visitor_last_message.message : "",
                channel: data.visitor_source,
                team: data.team_name,
                id: ticket.id,
                key: index,
                date: moment(ticket.created_at).format("DD/MM/YYYY, h:mm a")

            }
        });
    } else {
        endResults.data = tickets.data.map((ticket, index) => {
            return {
                name: `${ticket.visitor_first_name ? ticket.visitor_first_name : "Unknown"} ${ticket.visitor_last_name || ""}`,
                email: ticket.visitor_email,
                phone: ticket.visitor_phone || null,
                last_message: ticket.visitor_last_message ? ticket.visitor_last_message.message : "",
                channel: ticket.visitor_source,
                team: ticket.team.name,
                id: ticket.id,
                key: index,
                date: moment(ticket.created_at).format("DD/MM/YYYY, h:mm a"),
                agent: ticket.platform_user ? `${ticket.platform_user.first_name} ${ticket.platform_user.last_name}`: "",
                platform_user : ticket.platform_user,
                visitor_id : ticket.visitor_id
            }
        });
    }

    console.log("endResults", endResults);
    return endResults;
}

export function* getTicketsSaga() {
    yield takeEvery(GET_TICKETS, function* (action) {
        try {
            const response = yield apiService.get(`/hulk/api/v1/${action.payload.endpoint}`, {}, { ...action.payload.query });

            if (response.status == "success") {
                yield put(saveTickets(convertTicketFormatToUiFormat(action.payload.endpoint, response.data)));
            } else {
                toastNotification({ errorMessage: "Unable to fetch tickets" });
            }
        } catch (error) {
            toastNotification({ errorMessage: "Some Error Occurred" });
        }
    });
}

export default function* rootSaga() {
    yield all([
        getTicketsSaga()
    ]);
}
